import { SOURCE_INDEX } from './sources';
import './Cite.css';

/**
 * A numbered reference to an entry in the sources list. Renders nothing if the
 * id is unknown, so a typo can never surface a broken marker to a reader.
 */
export function Cite({ id }: { id: string }) {
  const number = SOURCE_INDEX[id];
  if (!number) return null;

  return (
    <a className="Cite" href={`#source-${number}`} aria-label={`Source ${number}`}>
      {number}
    </a>
  );
}
